import { IconClose, IconFavorite } from "app/components/Icon/Icon";
import cx from "classnames";
import React from "react";
import ENV from "../../../../../../../../config";

type Props = {
  bookmarksOnly: boolean;
  favouritesOnly: boolean;
  onClickFavourites: (...args: Array<any>) => any;
  isCompetitionListLoading: boolean;
  currentFavouritesCount: any;
};

const FavouritesButton: React.FC<Props> = ({
  bookmarksOnly,
  favouritesOnly,
  onClickFavourites,
  isCompetitionListLoading,
  currentFavouritesCount,
}) => {
  return (
    <button
      id="Favorite"
      onClick={() => onClickFavourites()}
      disabled={isCompetitionListLoading}
      className={cx(
        "events-screen-header__options__search-button",
        {
          "events-screen-header__options__search-button--favourites-active":
            favouritesOnly,
        },
        {
          disabled: isCompetitionListLoading || ENV.PUBLIC_VIEW === "TRUE",
          collapse: bookmarksOnly,
        },
        {
          "searchbar-icons__asian": true,
        }
      )}
    >
      <div
        className={
          currentFavouritesCount === 0 && !favouritesOnly
            ? "hide badge"
            : "badge"
        }
      >
        {favouritesOnly ? (
          <span
            className="asian-events-screen-header__icon-close"
            data-qa="favourites-header__icon-close"
          >
            <IconClose />
          </span>
        ) : (
          <div>{currentFavouritesCount}</div>
        )}
      </div>
      <IconFavorite />
    </button>
  );
};

export default FavouritesButton;
